var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.21 42.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M104.79,12.63h-7.71v-3.68C97.08,4,93.07,0,88.13,0H8.95C4.01,0,0,4,0,8.95v24.48C0,38.37,4.01,42.38,8.95,42.38h79.18c4.94,0,8.95-4.01,8.95-8.95v-3.69h7.71c2.44,0,4.42-1.98,4.42-4.42v-8.27c0-2.44-1.98-4.42-4.42-4.42ZM91.41,33.43c0,1.81-1.47,3.28-3.28,3.28H8.95c-1.81,0-3.28-1.47-3.28-3.28V8.95c0-1.81,1.47-3.28,3.28-3.28h79.18c1.81,0,3.28,1.47,3.28,3.28v24.48Z",
    style: {
      fill: "#133c46"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.67,
    y: 5.67,
    width: 17.15,
    height: 31.04,
    rx: 3.28,
    ry: 3.28
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.54,6.67c1.26,0,2.28,1.02,2.28,2.28v24.48c0,1.26-1.02,2.28-2.28,2.28h-10.59c-1.26,0-2.28-1.02-2.28-2.28V8.95c0-1.26,1.02-2.28,2.28-2.28h10.59M19.54,5.67h-10.59c-1.81,0-3.28,1.47-3.28,3.28v24.48c0,1.81,1.47,3.28,3.28,3.28h10.59c1.81,0,3.28-1.47,3.28-3.28V8.95c0-1.81-1.47-3.28-3.28-3.28h0Z",
    style: {
      fill: "#fff"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.82,
    y: 5.67,
    width: 17.15,
    height: 31.04,
    rx: 3.28,
    ry: 3.28
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.69,6.67c1.26,0,2.28,1.02,2.28,2.28v24.48c0,1.26-1.02,2.28-2.28,2.28h-10.59c-1.26,0-2.28-1.02-2.28-2.28V8.95c0-1.26,1.02-2.28,2.28-2.28h10.59M36.69,5.67h-10.59c-1.81,0-3.28,1.47-3.28,3.28v24.48c0,1.81,1.47,3.28,3.28,3.28h10.59c1.81,0,3.28-1.47,3.28-3.28V8.95c0-1.81-1.47-3.28-3.28-3.28h0Z",
    style: {
      fill: "#fff"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.97,
    y: 5.67,
    width: 17.15,
    height: 31.04,
    rx: 3.28,
    ry: 3.28
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.84,6.67c1.26,0,2.28,1.02,2.28,2.28v24.48c0,1.26-1.02,2.28-2.28,2.28h-10.59c-1.26,0-2.28-1.02-2.28-2.28V8.95c0-1.26,1.02-2.28,2.28-2.28h10.59M53.84,5.67h-10.59c-1.81,0-3.28,1.47-3.28,3.28v24.48c0,1.81,1.47,3.28,3.28,3.28h10.59c1.81,0,3.28-1.47,3.28-3.28V8.95c0-1.81-1.47-3.28-3.28-3.28h0Z",
    style: {
      fill: "#fff"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57.12,
    y: 5.67,
    width: 17.15,
    height: 31.04,
    rx: 3.28,
    ry: 3.28
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.98,6.67c1.26,0,2.28,1.02,2.28,2.28v24.48c0,1.26-1.02,2.28-2.28,2.28h-10.59c-1.26,0-2.28-1.02-2.28-2.28V8.95c0-1.26,1.02-2.28,2.28-2.28h10.59M70.98,5.67h-10.59c-1.81,0-3.28,1.47-3.28,3.28v24.48c0,1.81,1.47,3.28,3.28,3.28h10.59c1.81,0,3.28-1.47,3.28-3.28V8.95c0-1.81-1.47-3.28-3.28-3.28h0Z",
    style: {
      fill: "#fff"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74.26,
    y: 5.67,
    width: 17.15,
    height: 31.04,
    rx: 3.28,
    ry: 3.28
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.13,6.67c1.26,0,2.28,1.02,2.28,2.28v24.48c0,1.26-1.02,2.28-2.28,2.28h-10.59c-1.26,0-2.28-1.02-2.28-2.28V8.95c0-1.26,1.02-2.28,2.28-2.28h10.59M88.13,5.67h-10.59c-1.81,0-3.28,1.47-3.28,3.28v24.48c0,1.81,1.47,3.28,3.28,3.28h10.59c1.81,0,3.28-1.47,3.28-3.28V8.95c0-1.81-1.47-3.28-3.28-3.28h0Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.09946dca001cd7fbf1ec874c09e2f870.svg";
export { ForwardRef as ReactComponent };